// extracted by mini-css-extract-plugin
export var cardDescr = "CardsBlock-module--cardDescr--e1f94";
export var description = "CardsBlock-module--description--739ff";
export var image = "CardsBlock-module--image--11271";
export var panel = "CardsBlock-module--panel--f768f";
export var separator = "CardsBlock-module--separator--f6f22";
export var title = "CardsBlock-module--title--33f48";